import { AfterViewInit, Component, Input } from '@angular/core';
import { MarkdownService } from 'ngx-markdown';

@Component({
  selector: 'am-code',
  templateUrl: './code.component.html',
  styleUrls: ['./code.component.scss'],
})
export class CodeComponent implements AfterViewInit {
  constructor(public markdown: MarkdownService) {}

  @Input() language = 'html';

  get _lang() {
    return `language-${this.language}`;
  }

  ngAfterViewInit() {
    this.highlight();
  }

  highlight() {
    this.markdown.highlight();
  }
}
